<mat-tab-group mat-stretch-tabs="false" (selectedTabChange)="tabClick($event)" [(selectedIndex)]="tabIndex" animationDuration="0ms" class="square">
  <ng-container *ngFor="let tab of tabList; index as i">
    <mat-tab *ngIf="tab['privilege']" [label]="utilities.mapKeyToString(TabListLabel, tab['labelKey'])">
      <ng-template matTabLabel> {{ utilities.mapKeyToString(TabListLabel, tab['labelKey']) }} ({{ tab['dataCount'] | async }}) </ng-template>
      <ng-container *ngIf="i === tabIndex && tab.component">
        <ng-container *ngComponentOutlet="tab.component"></ng-container>
      </ng-container>
    </mat-tab>
  </ng-container>
</mat-tab-group>
